import { RatingCreatorType } from './enums'

export class Rating {
    jobId: string
    clientId?: string
    haulerId?: string
    message?: string
    creator?: RatingCreatorType
    stars: number
    createDate?: number
    modifyDate?: number
}



// WEBPACK FOOTER //
// ./src/types/Rating.ts